import Vue from 'vue';
import Vuex from 'vuex';
import companies from './companies';
import leads from './leads';
import metadata from './metadata';
import trades from './trades';
import zips from './zips';
import nav from './nav';
import rules from './rules';
import { auth } from './modules/auth';
import { ui } from './modules/ui';

Vue.use(Vuex);

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */
export const store = new Vuex.Store({
   modules: {
      auth,
      ui,
      trades,
      zips,
      companies,
      leads,
      metadata,
      nav,
      rules,
   },
   plugins: [],

   // enable strict mode (adds overhead!)
   // for dev mode only
   strict: process.env.DEV,
});

export default store;
